import { render, staticRenderFns } from "./RelLog.vue?vue&type=template&id=c01991b4&scoped=true&"
import script from "./RelLog.vue?vue&type=script&lang=js&"
export * from "./RelLog.vue?vue&type=script&lang=js&"
import style0 from "./RelLog.vue?vue&type=style&index=0&id=c01991b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c01991b4",
  null
  
)

export default component.exports